<template>
  <div>
    <v-file-input
    label="File input"
    hide-input
    v-model="uploadFile"
    type="file"
    ref="pickFile"
    style="display: none"
    @change="doUpload"
    prepend-icon="mdi-upload"
  ></v-file-input>
    
  <div class="thumb-image" @mouseover="showUploadIcon = true" @click.prevent="showBigImage"
    @mouseleave="() => {if(picture) showUploadIcon = false}">
    
    <div class="thumb-image__upload-section" v-if="showUploadIcon">
      <v-btn class="" elevation="0" light  rounded color="#878889" fab text x-small @click.stop="pickFile">
            <v-icon >mdi-upload</v-icon>
          </v-btn>
          
    </div>
      <template v-if="picture">
        <img
          :src="picture"
          alt="#"
        />
      </template>
      <template v-else>
        <div class="thumb-image__default">
          
        </div>
      </template>
  </div>

</div>
</template>

<script>
  export default {
    name: "ThumbItemImage",
    props: {
      image: {
        type: String,
      },
      type: {
        type: String,
        required: true
      },
      bundleId: {
        type: Number
      }
    },
    data(){
      return {
        picture: '',
        showUploadIcon: false,
        uploadFile: null,
        isUploading: false,
      }
    },
    created(){
      this.picture = this.image;
      if(!this.picture){
        this.showUploadIcon = true;
      }
    },
    methods: {
      showBigImage(){
        if(this.picture){
          this.$emit('showBigImage', this.picture);
        }else{
          this.pickFile();
        }
      },
      pickFile(){
        this.$refs.pickFile.$refs.input.click();
      },
      doUpload(file){
        if (typeof file == "undefined" || file == null) {
        return false;
      }

      this.isUploading = true;

      let formData = new FormData();
      formData.append("file", file, file.name);

      // additional data
      formData.append("key", "file");
      formData.append("bundle_id", this.bundleId);
      formData.append("field", this.type);
      this.axios
        .post("/upload", formData)
        .then((response) => {
          this.picture = response.data.url;
          setTimeout(() => {
            this.isUploading = false;
          }, 1000);
        })
        .catch((error) => {
          console.error({ error });
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
    .thumb-image{
      height: 60px;
      width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: .1em;
    z-index: 10;


      & > img{
        cursor: pointer;
        width: 60px;
        height: 100%;
        visibility: visible;
        object-fit: cover;
        background-color: transparent;
        object-position: center;
        backdrop-filter: inherit;
        object-fit: contain;
        filter: none;
        display: block;
        padding: .5em .2em;
        z-index: 1;
        &:hover {
          display: block;
          filter: none;
        }
      }

      &__default{
        display: flex;
        width: 100%;
        cursor: pointer;
        height: 100%;
        border: 1px solid #ccc;
      }

      &__upload-section{
        border: 1px solid #ccc;
        position: absolute;
        background: rgba(255,255,255,0.8);
        width: 100%;
        height: 100%;
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        bottom: 0;
        right: 0;
        z-index: 100;

      }
      
    }
</style>
